import { faExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { TooltipIconWrap } from './style'

type TErrorTooltipProps = {
  message: string
}

export const ErrorTooltip = ({ message }: TErrorTooltipProps) => {
  return (
    <Tooltip text={message} hasArrow>
      <TooltipIconWrap>
        <FontAwesomeIcon
          icon={faExclamation}
          size="xs"
          data-testid="error-tooltip-icon"
        />
      </TooltipIconWrap>
    </Tooltip>
  )
}
